import { useState } from "react";
import { Button } from "./ui/button";
import { Download, FileText, FileSpreadsheet, ChevronDown } from "lucide-react";

export default function ExportButton({ onExport, label = "Exporter", testId = "export-btn" }) {
  const [open, setOpen] = useState(false);

  const handle = (fmt) => {
    setOpen(false);
    onExport(fmt);
  };

  return (
    <div className="relative inline-block">
      <Button
        size="sm"
        variant="outline"
        onClick={() => setOpen(o => !o)}
        className="border-[#CBD5E1] h-9 gap-1.5"
        data-testid={testId}
      >
        <Download className="w-3.5 h-3.5" /> {label}
        <ChevronDown className={`w-3 h-3 transition-transform ${open ? "rotate-180" : ""}`} />
      </Button>
      {open && (
        <>
          <div className="fixed inset-0 z-30" onClick={() => setOpen(false)} />
          <div className="absolute right-0 mt-1 w-44 bg-white border border-[#CBD5E1] rounded-lg shadow-lg z-40 overflow-hidden" data-testid={`${testId}-menu`}>
            <button
              onClick={() => handle("csv")}
              className="w-full px-3 py-2 text-left text-xs font-medium text-[#0A2540] hover:bg-[#F8FAFC] flex items-center gap-2"
              data-testid={`${testId}-csv`}
            >
              <FileText className="w-3.5 h-3.5 text-[#3B82F6]" /> Format CSV
            </button>
            <button
              onClick={() => handle("xlsx")}
              className="w-full px-3 py-2 text-left text-xs font-medium text-[#0A2540] hover:bg-[#F8FAFC] flex items-center gap-2 border-t border-[#E2E8F0]"
              data-testid={`${testId}-xlsx`}
            >
              <FileSpreadsheet className="w-3.5 h-3.5 text-[#10B981]" /> Format Excel
            </button>
          </div>
        </>
      )}
    </div>
  );
}
